export const DEFAULT_PHOTO_ALBUM_PHOTO_COUNT = 40;
export const ALBUM_GENERATION_TIME_MINUTES = 15;
export const MODEL_TRAINING_TIME_MINUTES = 5;
export const MIN_TRAINING_IMAGES = 8;
export const MAX_TRAINING_IMAGES = 16;
export const IMAGE_MIN_DIMENSIONS = "Minimum 512px width and height;";
export const IMAGE_SIZE_LIMIT = "Max 10MB each;";
export const IMAGE_ACCEPTED_FORMATS = "PNG, JPG, HEIC, WEBP";